
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"15","viewBox":"0 0 19 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.8686 6.70724L16.0042 3.20701C15.8729 3.02963 15.6579 2.91138 15.4191 2.91138H11.5737C11.1796 2.91138 10.8571 3.23066 10.8571 3.62089V11.8039C10.8571 12.1941 11.1796 12.5134 11.5737 12.5134H11.6095C11.6931 11.0944 12.8873 9.97098 14.3443 9.97098C15.8012 9.97098 16.9954 11.0944 17.079 12.5134L18.2835 12.537C18.6776 12.537 19 12.2178 19 11.8275V7.12112C19 6.9674 18.9522 6.82549 18.8686 6.70724ZM17.1905 7.7242H12.6365C12.4813 7.7242 12.3499 7.59413 12.3499 7.4404V4.69697C12.3499 4.54325 12.4813 4.41317 12.6365 4.41317H15.1444L17.4413 7.22755C17.5965 7.42858 17.4532 7.7242 17.1905 7.7242ZM16.1595 12.7026C16.1595 13.6959 15.3474 14.5 14.3443 14.5C13.3411 14.5 12.529 13.6959 12.529 12.7026C12.529 11.7093 13.3411 10.8933 14.3443 10.8933C15.3474 10.8933 16.1595 11.7093 16.1595 12.7026ZM9.95238 1.19768V11.8275C9.95238 12.2178 9.62994 12.5252 9.24779 12.5252H7.71095C7.62735 11.1062 6.43314 9.9828 4.97619 9.9828C3.51925 9.9828 2.32503 11.1062 2.24143 12.5252H0.704588C0.310497 12.5252 0 12.2059 0 11.8275V1.19768C0 0.819278 0.322439 0.5 0.704588 0.5H9.23585C9.62994 0.5 9.95238 0.819278 9.95238 1.19768ZM6.7914 12.7026C6.7914 13.6959 5.97933 14.5 4.97619 14.5C3.97305 14.5 3.16098 13.6959 3.16098 12.7026C3.16098 11.7093 3.97305 10.8933 4.97619 10.8933C5.97933 10.8933 6.7914 11.7093 6.7914 12.7026Z","fill":"white"}})])
          )
        }
      }
    